<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    persistent
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        {{ text }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :key="actionLabel"
          color="primary"
          text
          @click="onSubmit"
        >
          {{ actionLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
  },
  props: {
    title: { type: String, required: true },
    text: { type: String, required: true },
    actionLabel: { type: String, default: 'OK' }
  },
  methods: {
    onSubmit () {
      this.$emit('resolve', true)
    }
  }
}
</script>
